import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import SectionHeading from "@/components/feature/SectionHeading";

export default function NewsList() {
  const [featured, ...rest] = news;

  return (
    <section className="border-y border-background-200/50 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Latest News"
          title="最新电影资讯"
          description="掌握院线动态、票房表现与幕后故事，第一时间了解正在发生的电影圈大事。"
          moreTo="/list/news"
          moreLabel="更多资讯"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Link
            to={`/detail/${featured.movieId}`}
            className="group relative overflow-hidden rounded-lg border border-background-200/60 bg-background-200/40"
          >
            <div className="relative h-56 w-full overflow-hidden md:h-72 lg:h-full lg:min-h-[380px]">
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} - 黄色大片 电影资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/45 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <div className="mb-3 flex items-center gap-3 text-xs">
                <span className="rounded-sm bg-primary-500 px-2 py-0.5 font-label uppercase tracking-wide text-foreground-950">
                  {featured.tag}
                </span>
                <span className="text-foreground-300">{featured.date}</span>
              </div>
              <h3 className="font-heading text-lg font-bold leading-snug text-foreground-50 md:text-xl">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-2 hidden text-sm leading-relaxed text-foreground-300 sm:block">
                {featured.excerpt}
              </p>
            </div>
          </Link>

          <div className="flex flex-col gap-3">
            {rest.map((item) => (
              <Link
                key={item.id}
                to={`/detail/${item.movieId}`}
                className="group flex gap-4 rounded-lg border border-background-200/50 bg-background-50 p-3 transition-colors hover:border-primary-400/60 md:p-4"
              >
                <div className="h-20 w-28 flex-shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-36">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 黄色大片 电影资讯`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex items-center gap-2 text-xs">
                    <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 font-label uppercase tracking-wide text-accent-400">
                      {item.tag}
                    </span>
                    <span className="text-foreground-500">{item.date}</span>
                  </div>
                  <h3 className="mt-2 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-50 group-hover:text-primary-400 md:text-base">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 hidden text-xs leading-relaxed text-foreground-400 md:block">
                    {item.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}